import { render } from "./ReferenceResultView.vue?vue&type=template&id=0b9a539c"
import script from "./ReferenceResultView.vue?vue&type=script&lang=js"
export * from "./ReferenceResultView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__